import axios from "axios";
import box from "../utils/index";

// 创建axios实例
let service = axios.create({
  timeout: 60000, // 请求超时时间
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    webType: "admin"
  }
});

//api url
const rootBaseURL = process.env.VUE_APP_ROOT_API;
const adminBaseURL = process.env.VUE_APP_ADMIN_API;

// request拦截器：对请求参数做监听和处理
service.interceptors.request.use(
  config => {
    config.headers.token = localStorage.getItem("token");
    config.headers.usertoken = localStorage.getItem("token");
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response拦截器：对相应数据做处理
service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

const requestMethod = ["get", "delete", "post", "put", "patch"];

const $axios = {};

requestMethod.forEach(method => {
  $axios[method] = function(url, data = {}) {
    const baseURL = url.slice(0, 4) === "/oa/" ? adminBaseURL : rootBaseURL;

    return new Promise((resolve, reject) => {
      if (method === "get") {
        if (url.slice(0, 9) === "/api/user") {
          service[method](`${baseURL}${url}`, { cache: false })
            .then(
              response => {
                packageRespon(response, resolve);
              },
              err => {
                packageError(err);
              }
            )
            .catch(error => {
              reject(error);
              packageCatch(error);
            });
        } else {
          service[method](`${baseURL}${url}?_${Date.now()}`, { cache: false })
            .then(
              response => {
                packageRespon(response, resolve);
              },
              err => {
                packageError(err);
              }
            )
            .catch(error => {
              reject(error);
              packageCatch(error);
            });
        }
      } else {
        if (!service.defaults.headers.token) {
          service.defaults.headers.token = box.loadLocal("token", true);
        }
        service[method](baseURL + url, data)
          .then(
            response => {
              packageRespon(response, resolve);
            },
            err => {
              packageError(err);
            }
          )
          .catch(error => {
            reject(error);
            packageCatch(error);
          });
      }
    });
  };
});

function packageRespon(res, resolve) {
  if (res.status == 200) {
    resolve(res);
  } else {
    box.alert("", res.data.message, "error");
    box.loadings(2);
  }
}

function packageError(err, url) {
  if (err !== "Operationcanceled" && err.message !== "Operationcanceled") {
    if (err == "Error: timeout of 60000ms exceeded") {
      box.alert("", "Unable to connect to the server.", "error");
    } else if (
      err == "Error: Network Error" ||
      err.message == "Network Error"
    ) {
      box.alert("", "Unable to connect to the server.", "error");
    } else {
      box.alert("", err, "error");
    }
  }
}

function packageCatch(err) {
  box.alert("", err, "error");
}

export default $axios;



// WEBPACK FOOTER //
// ./src/api/axios.js